export default "__VITE_PUBLIC_ASSET__43ffbc2f__"